import ProcessGroup1 from "../../assets/images/process-1.png";
import ProcessGroup2 from "../../assets/images/process-2.png";
import ProcessGroup3 from "../../assets/images/process-3.png";
import ProcessGroup4 from "../../assets/images/process-4.png";
import ArrowRight from "../../assets/images/arrow-right.png";

import YellowBox3 from "../../assets/images/yellow-box-3.png";
import PurpleBox2 from "../../assets/images/purple-box-2.png";
import Stick from "../../assets/images/stick.png";

/** New Design  */

const Process = (props) => {
  return (
    <section
      id={props.currentLang === "eng" ? "process" : "surec"}
      className="w-full flex justify-center pt-28 pb-20 sm:pb-40 lg:pb-64 relative"
    >
      <div className="w-4/5 max-w-screen-xl flex justify-center items-center flex-col space-y-5 md:space-y-10">
        <div>
          <h2 className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-[#1F36C7] font-bold text-center">
            {props.currentLang === "eng" ? "PROCESS" : "SÜREÇ"}
          </h2>
        </div>
        {/* New Design */}
        <div className="flex flex-col sm:flex-wrap lg:flex-nowrap sm:flex-row lg:space-x-2 xl:space-x-7 text-center items-center justify-center">
          <div className="relative flex items-center justify-center m-7 my-16 lg:m-0">
            <img
              className="w-[270px]"
              src={ProcessGroup1}
              alt="ProcessGroup1"
            />
            <img
              className="hidden lg:block absolute w-14 xl:w-20 lg:-right-8 xl:-right-14 top-[33%] z-[1]"
              src={ArrowRight}
              alt="arrow right"
            />
            <p
              data-aos="zoom-in"
              className="absolute text-base lg:text-lg xl:text-2xl font-bold text-[#1F36C7]"
            >
              {props.currentLang === "eng" ? "APPLICATION" : "BAŞVURU"}
            </p>
            <div className="absolute top-48 lg:top-40 xl:top-52 flex flex-col items-center w-full">
              <img className="w-4 " src={Stick} alt="stick" />
              {props.currentLang === "eng" ? (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  14 April 2023
                  <br /> - <br /> 5 May 2023
                </p>
              ) : (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  14 Nisan 2023
                  <br /> - <br /> 5 Mayıs 2023
                </p>
              )}
            </div>
          </div>

          <div className="relative flex items-center justify-center m-7 my-16 lg:m-0">
            <img
              className="w-[270px]"
              src={ProcessGroup3}
              alt="ProcessGroup3"
            />
            <img
              className="hidden lg:block absolute w-14 xl:w-20 lg:-right-8 xl:-right-14 top-[33%] z-[1]"
              src={ArrowRight}
              alt="arrow right"
            />

            {props.currentLang === "eng" ? (
              <p
                data-aos="zoom-in"
                className="absolute text-base lg:text-lg xl:text-2xl font-bold text-[#1F36C7]"
              >
                PARTICIPANTS <br /> ANNOUNCEMENT
              </p>
            ) : (
              <p
                data-aos="zoom-in"
                className="absolute text-base lg:text-lg xl:text-2xl font-bold text-[#1F36C7]"
              >
                KATILIMCI <br /> DUYURUSU
              </p>
            )}
            <div className="absolute top-48 lg:top-40 xl:top-52 flex flex-col items-center w-full">
              <img className="w-4 " src={Stick} alt="stick" />
              {props.currentLang === "eng" ? (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  {" "}
                  5 May 2023
                </p>
              ) : (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  5 Mayıs 2023
                </p>
              )}
            </div>
          </div>
          <div className="relative flex items-center justify-center m-7 my-16 lg:m-0">
            <img
              className="w-[270px]"
              src={ProcessGroup2}
              alt="ProcessGroup2"
            />
            <img
              className="hidden lg:block absolute w-14 xl:w-20 lg:-right-8 xl:-right-14 top-[33%] z-[1]"
              src={ArrowRight}
              alt="arrow right"
            />
            <p
              data-aos="zoom-in"
              className="absolute text-2xl md:text-3xl lg:text-4xl font-bold text-[#1F36C7]"
            >
              {props.currentLang === "eng" ? "DAY 1" : "DAY 1"}
            </p>
            <div className="absolute top-48 lg:top-40 xl:top-52 flex flex-col items-center w-full">
              <img className="w-4 " src={Stick} alt="stick" />
              {props.currentLang === "eng" ? (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  11 May 2023 <br /> Meet the digital teams with live broadcast.
                </p>
              ) : (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  11 Mayıs 2023 <br /> Canlı yayın ile dijital ekiplerle tanışın
                </p>
              )}
            </div>
          </div>

          <div className="relative flex items-center justify-center m-7 my-16 lg:m-0">
            <img
              className="w-[270px]"
              src={ProcessGroup4}
              alt="ProcessGroup4"
            />
            <p
              data-aos="zoom-in"
              className="absolute text-2xl md:text-3xl lg:text-4xl font-bold text-[#1F36C7]"
            >
              {props.currentLang === "eng" ? "DAY 2" : "DAY 2"}
            </p>
            <div className="absolute top-48 lg:top-40 xl:top-52 flex flex-col items-center w-full">
              <img className="w-4 " src={Stick} alt="stick" />
              {props.currentLang === "eng" ? (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  {" "}
                  12 May 2023 <br /> Experience a real life case online.
                </p>
              ) : (
                <p
                  data-aos="fade-up"
                  className="text-base md:text-xl lg:text-2xl text-[#1F36C7] font-bold"
                >
                  12 Mayıs 2023 <br /> Gerçek bir vakayı online deneyimleyin.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <img
        className="absolute w-20 sm:w-28 left-[7%] top-14"
        src={YellowBox3}
        alt="yellow box"
      />
      <img
        className="absolute w-40 md:w-56 left-[15%] -top-20 animate-[wiggle_10s_ease-in-out_infinite]"
        src={PurpleBox2}
        alt="purple box"
      />
    </section>
  );
};

export default Process;
